import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { Globals } from "app/globals";
import { PlatformLocation } from '@angular/common';
import { ClientsService, ProcessAssessmentDto, SaveQuestionDto } from 'app/services/client/ClientsService';
import { AssessmentsService } from 'app/services/assessment/AssessmentsService';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { TranslateService } from '@ngx-translate/core';
import { isUndefined } from 'util';
import { RatersService } from '../app/services/rater/RatersService';
import { CryptoJs } from '../app/shared/crypto-js/crypto-js.component';
import { AdminService } from '../app/services/admin/AdminService';
import { isNull } from 'util';
import { UserLoggedInService } from '../app/services/angular/UserLoggedIn';
import { Idle } from '@ng-idle/core';

@Component({
  selector: 'app-accessible-self-assessment',
  templateUrl: './accessible-self-assessment.component.html',
  styleUrls: ['./accessible-self-assessment.component.scss']
})
export class AccessibleSelfAssessmentComponent implements OnInit {

    user = {
        email: null,
        pass: null
    }
    authenticateUserData: any;

    loadingShortcut: boolean = true;

    //instruction
    from: string;
    assessmentId: number = -1;
    assignmentId: number;
    hasId: boolean = false;
    once: boolean = true;

    ready: boolean = false;
    //instruction

    @ViewChild('selects', { static: false }) selectsElement: ElementRef;

    finish: boolean = false;
    questionsTotal: number = 0;
    from_client: boolean;
    from_admin: boolean;
    previewMode: boolean;
    showAssessment: boolean = false;
    loading: boolean = true;
    questionsContent: boolean = true;
    showNextIcon: boolean = true;
    currentQuestionId: number = 0;
    currentSectionId: number = 0;
    currentQuestionIndex: number = 0;
    currentSectionIndex: number = 0;
    showIcons: boolean;
    singleChoice: boolean;
    displayMode: number;

    sections: any[] = [];
    currentSectionChoices: any[] = [];
    multipleQuestions: any[] = [];
    questionChoices: any[] = [];

    globalCurrentQuestion: number = 1;
    currentChoiceSetId: number;

    assessmenProcess: any[] = [];

    showDownButtons: boolean = false;
    responsiveButtons: boolean = false;
    currentAssessmentName: string = "";

    //Graphic1
    ERGraphicDatasets: any[] = [];
    ERGraphicLabel: string[] = [];
    ERGraphicOptions: any = {
        scaleShowVerticalLines: true,
        responsive: true,
        scales: {
            xAxes: [{
                display: false,
                ticks: {
                    beginAtZero: true
                }
            }]
        },
        tooltips: {
            enabled: true
        },
        hover: {
            animationDuration: 5
        }
    };

    ERGraphicLegend: boolean = false;
    ERGraphicChartType: string = 'horizontalBar';

    colors: Array<any> = [
        { // blue
            backgroundColor: "#1588eb",
            borderColor: "rgba(0,192,192,1)",
            pointBorderColor: "rgba(0,181,255,1)",
            pointBackgroundColor: "rgba(255,255,255,1)",
            pointBorderWidth: 1,
        }
    ];

    //Graphic2
    ERPGraphicDatasets: any[] = [];
    ERPGraphicLabel: string[] = [];
    ERPGraphicOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true,
        scales: {
            xAxes: [{
                display: false,
                ticks: {
                    beginAtZero: true
                }
            }]
        },
    };
    ERPGraphicLegend: boolean = false;
    ERPGraphicChartType: string = 'horizontalBar';

    ARL: any;
    EP: any;
    ESR: any;

    loadingMessage: string = "Loading Asessment, please wait...";
    graphicTitle1: string = '';
    graphicTitle2: string = '';

    levels1: any[] = [];
    levels2: any[] = [];

    userType: number;

    assessment360Finished: boolean = false;
    final360Message: string;

    selectModeClone: any;
    hideNavigationBtns: boolean = false;

    downloadTimer: any;
    timeleft: number = 900;
    currentHeader: string = "";
    language: string = "";
    data: any;
    pageContent: any;
    fullName: any;
    showCommentsSection: boolean = false;
    onCommentsPage: boolean = false;
    clientInfo = {
        FirstName: "",
        LastName: ""
    };

    gettingData = new Array<string>();
    ngProgressRef: NgProgressRef;
    guidId: string = '';
    assessmentValid: boolean = true;

    constructor
        (
            private _ClientsService: ClientsService,
            private _AssessmentsService: AssessmentsService,
            private _AdminService: AdminService,
            private _RatersService: RatersService,
            private activatedRoute: ActivatedRoute,
            private toastr: ToastrService,
            private router: Router,
            private _Globals: Globals,
            location: PlatformLocation,
            public ngProgress: NgProgress,
            public translate: TranslateService,
            private _CryptoJs: CryptoJs,
            private _UserLoggedInService: UserLoggedInService,
            private idle: Idle
    ) {
        this.activatedRoute.params.subscribe(params =>
        {
            console.log('params', params);

            this.guidId = params['id'];          

            //if (isNaN(params['id'])) {
            //    this.toastr.error('No valid assessment id', 'ELI');
            //    return;
            //}
        });

        //changing the browser url
/*        window.history.pushState({ "html": "", "pageTitle": "" }, "", "app/assessment");*/

        //detecting the go back browser button
        location.onPopState(() => {
            console.log('pressed back!');
            if (this.once) {
                setTimeout(() => {
                    this.router.navigate(['/app/client_assessments']);
                }, 100);
                //    window.history.go(-2); 
                this.once = false;
            }
        });

        //this.authenticateUser("clswhitaker@gmail.com","GBrite22hhp$");  //old user
        this.authenticateUser();
    }

    ngOnInit() {
        this.ngProgressRef = this.ngProgress.ref();
        this.ngProgressRef.start();

        /*this.getPageContent(this.assessmentId, this.language);*/
        //if (!this._Globals.previewMode) {
        //    this.getPageContentByUserType(this.assessmentId, 1, this.language, this.userType, 'pageContent');
        //} else {
        //    this.setPreviewPageContent(this._Globals.instructionsPageContent, 'pageContent');
        //}

    }

    @HostListener('window:keydown.alt.b', ['$event'])
    shortcutBackQuestion(event: KeyboardEvent) {
      event.preventDefault();
      this.showPrevQuestion();
      document.getElementById("numberQuestion").focus();
    }

    @HostListener('window:keydown.alt.n', ['$event'])
    shortcutNextQuestion(event: KeyboardEvent) {
      event.preventDefault();
      this.showNextQuestion();
      document.getElementById("numberQuestion").focus();
    }

    @HostListener('window:keydown.alt.q', ['$event'])
    shortcutShowQuestion(event: KeyboardEvent) {
      event.preventDefault();
      document.getElementById("isQuestion").focus();
    }

    @HostListener('window:keydown.alt.s', ['$event'])
    shortcutStartQuestion(event: KeyboardEvent) {
      event.preventDefault();
      if (this.loadingShortcut === false) {
        this.userReady();
      }

    }

    setPreviewPageContent(content: string, divId: string) {
        this.loading = false;
        setTimeout(() => {
            this.pageContent = content;
            if (this.pageContent == "") {
                this.pageContent = '<div style="text-align:center;margin-top:20px;"><i class="fas fa-exclamation-triangle"></i> No content.</div>';
            }

            $('#' + divId).html(this.pageContent);
            $('.ql-align-justify img').css('width', '100%');
            $('p img').css('margin', '3px 0');
            $('p').css('margin', '0px');

            let w = $(window).width();
            console.log(w);
            if (w < 1260) {
                $('p img').css('display', 'list-item');
            }
        }, 500);
    }

    getAssignedAssessment() {
        this.loadingShortcut = true;
        this.toastr.warning('Loading assessment.', 'ELI');
        this.gettingData.push('getAssignedAssessment');
        this._ClientsService.getAssignedAssessment(this.assignmentId, this.userType).subscribe((_data: any) => {
            console.log('response_GetAssignedAssessment', _data);

            if (this._Globals.validationToken(_data.result.Result)) {
                if (_data.result.Result != 0) {
                    let data = JSON.parse(_data.result.Data);
                    this.data = data;
                    this.clientInfo.FirstName = data.ClientInfo.FirstName;
                    this.clientInfo.LastName = data.ClientInfo.LastName;
                    console.log('GetAssignedAssessment', data);
                } else {
                    this.data = this._Globals.previewModeJSON;
                }

                this.ngProgressRef.complete();
                this.loading = false;
                
            }
            this.loadingShortcut = false;
            this.gettingData.splice(this.gettingData.indexOf('getAssignedAssessment'), 1);
            this.toastr.success('Loading assessment completed. Press tab for instructions or Alt S to begin the assessment.', 'ELI');
        });
    }

    ngOnDestroy() {
        console.log('on destroy');
        this.clearAll();
        $('.selectTitle').remove();
        $('.selectMode select').show();
        clearInterval(this.downloadTimer);
        this._Globals.previewMode = false;
        //this.downloadTimer = undefined;
        //delete(this.downloadTimer);

        //window.onpopstate = function (e) {
        //    window.history.go(-2);

        //};

    }

    //restartCountDown() {
    //    this.timeleft = 900;
    //}

    //countDown() {
    //    this.downloadTimer = setInterval(() => {
    //        document.getElementById("countdown").innerHTML = this.timeleft + " seconds remaining";
    //        this.timeleft -= 1;

    //        if (this.timeleft <= 0) {
    //            clearInterval(this.downloadTimer);
    //            document.getElementById("countdown").innerHTML = "Finished";
    //            console.log('time finished, loggin out user...');
    //            this._Globals.clearAllAndRediretToLogin();
    //            this.toastr.warning("You have been logged out cause we detected no activity from you for a 15 minutes period.", "ELI", {
    //                disableTimeOut: true,
    //                closeButton: true
    //            });
    //        }

    //    }, 1000);
    //}

    setAllBooleans(status: boolean) {
        this.from_admin = status;
        this.from_client = status;
    }

    getSectionIdPositionIndex(id: number, array: any[]): number {
        for (var i = 0; i < array.length; i++) {
            if (array[i].SectionId == id) {
                return i;
            }
        }
    }

    getQuestionIdPositionIndex(id: number, array: any[]): number {
        for (var i = 0; i < array.length; i++) {
            if (array[i].Id == id) {
                return i;
            }
        }
    }

    getTotalQuestions(array: any[]): number {
        for (var i = 0; i < array.length; i++) {
            if (array[i].ShowIcons || array[i].SingleChoice) {
                this.questionsTotal += array[i].Questions.length;
            }
        }

        return this.questionsTotal;
    }

    getChoicesForCurrentSection(choiceSetId: number) {
        this.gettingData.push('getAssessmentSectionChoices')
        this._ClientsService.getAssessmentSectionChoices(choiceSetId, this.language).subscribe(data => {
            console.log('response_GetAssessmentSectionChoices', data);
            this.currentSectionChoices = data.result;

            this.gettingData.splice(this.gettingData.indexOf('getAssessmentSectionChoices'), 1);
        });
    }

    setSectionProperties() {
        this.singleChoice = this.sections[this.currentSectionIndex].SingleChoice;
        this.showIcons = this.sections[this.currentSectionIndex].ShowIcons;
        this.displayMode = this.sections[this.currentSectionIndex].DisplayMode;
        console.log('singleChoice', this.singleChoice);
        console.log('showIcons', this.showIcons);
        console.log('DisplayMode', this.displayMode);

        if (this.singleChoice && this.displayMode == 2) { //this.showIcons &&
            this.multipleQuestions = this.sections[this.currentSectionIndex].Questions;
        }

        if (!this.singleChoice && !this.showIcons) {
            this.questionChoices = this.sections[this.currentSectionIndex].Questions;
            console.log('questionChoices', this.questionChoices);
            for (var i = 0; i < this.questionChoices.length; i++) {
                this.getQuestionChoices(this.questionChoices[i].Id, i);
            }
        }

    }

    getQuestionChoices(questionId: number, idx: number) {
        this.gettingData.push('getQuestionChoices');
        this._ClientsService.getQuestionChoices(questionId, this.language).subscribe(data => {
            //console.log('response_GetQuestionChoices', data);
            this.questionChoices[idx].Choices = data.result;

            if (this.questionChoices[idx].Answer && this.questionChoices[idx].Answer > 0) {

                const choice = this.questionChoices[idx].Choices.find((c: any) => Number(c.Id) === Number(this.questionChoices[idx].Answer));
                if (choice && choice.AllowFreeEntry) {
                    this.gettingData.push('getFreeEntryAnswer');
                    this._ClientsService.getFreeEntryAnswer(this.questionChoices[idx].Id, this.assignmentId)
                        .subscribe((response: any) => {
                            console.log('response_GetFreeEntryAnswer', response);

                            if (this._Globals.validationToken(response.result.Result)) {
                                if (response.result.Result != 0) {
                                    $('#input' + this.questionChoices[idx].Id).val(JSON.parse(response.result.Data));
                                    $('#input' + this.questionChoices[idx].Id).show();

                                    return;
                                }

                                this.toastr.error('We are sorry. Error while get answer.', 'ELI');
                            }

                        },
                            (err) => {
                                this.toastr.error('We are sorry. Error while get answer.', 'ELI');
                                this.gettingData.splice(this.gettingData.indexOf('getFreeEntryAnswer'), 1);
                            },
                            () => {
                                this.gettingData.splice(this.gettingData.indexOf('getFreeEntryAnswer'), 1);
                            });


                } else {
                    $('#input' + this.questionChoices[idx].Id).hide();
                }

                return;
            }

            $('#input' + this.questionChoices[idx].Id).hide();
        },
            (err) => {
                this.gettingData.splice(this.gettingData.indexOf('getQuestionChoices'), 1);
            },
            () => {
                this.gettingData.splice(this.gettingData.indexOf('getQuestionChoices'), 1);
            });
    }

    displayDownButtons() {
        var total = $('.isQuestion');
        var w = window.innerWidth;

        if (total.length > 1) {
            if (w < 992) {
                this.responsiveButtons = true;
                this.showDownButtons = true;
            } else {
                this.responsiveButtons = false;
                this.showDownButtons = false;
            }
        } else {
            if (w < 992) {
                this.showDownButtons = true;
                this.responsiveButtons = true;
            } else {
                this.showDownButtons = false;
                this.responsiveButtons = false;
            }
        }
        //console.log("W", w);
        //console.log('responsive Buttons', this.responsiveButtons);
    }

    onResize(event: any) {
        //console.log("Width: " , event.currentTarget.innerWidth);
        //console.log("Height: ", event.currentTarget.innerHeight);
        if (!this.finish) {
            if (event.currentTarget.innerWidth < 992) {
                this.showDownButtons = true;
                this.responsiveButtons = true;
            } else {
                this.showDownButtons = false;
                this.responsiveButtons = false;
            }
        } else {
            this.showDownButtons = false;
            this.responsiveButtons = false;
            $('#showDownButtons').hide();
        }
        //console.log("event.currentTarget.innerWidth", event.currentTarget.innerWidth);
        //console.log('responsive Buttons', this.responsiveButtons);

        let w = $(window).width();
        console.log(w);

        if (w < 1260) {
            $('p img').css('display', 'list-item');
        } else {
            $('p img').css('display', 'unset');
        }

        if (localStorage.getItem("ELIResponseError") == "1") {

            setTimeout(() => {
                /*adding disabled class to the back and next buttons*/
                $(".takingAssessment button").addClass("disabled");
            }, 10);
        } else {
            setTimeout(() => {
                /*removing disabled class to the back and next buttons*/
                $(".takingAssessment button").removeClass("disabled");
            }, 10);

        }
    }

    showNextQuestion() {

        //this.restartCountDown();

        if (!this.previewMode) {
            //validate regular questions
            if (!this.validateSingleQuestions()) {
                return;
            }

            //validate satisfaction questions
            if (!this.validateFacesQuestions()) {
                return;
            }

            //validate survey questions
            if (!this.validateSurveyQuestions()) {
                return;
            }
        }

        this.globalCurrentQuestion++;
        //if the current question index is less than the current section length, we display the next question
        if (this.currentQuestionIndex < (this.sections[this.currentSectionIndex].Questions.length - 1) && (this.displayMode != 2)) {

            let selectedAnswerId = this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Answer;

            console.log('selected answer id', selectedAnswerId);
            console.log('answers', this.currentSectionChoices);

            /*            $('#' + selectedAnswerId).addClass('active');*/
            $('#input' + selectedAnswerId).prop('checked', true);

            this.currentQuestionIndex++;
            console.log('currentQuestionIndex', this.currentQuestionIndex);
        } else {
            this.showNextSection();
        }

        if (this.sections.length != 0) {
            let lastSection = this.sections[this.sections.length - 1].SectionId;
            if (lastSection == this.currentSectionId) {
                //excluiding the multiple choices
                if (!this.singleChoice && !this.showIcons) {
                    this.currentQuestionId = this.sections[this.currentSectionIndex].Questions[this.sections[this.sections.length - 1].Questions.length - 1].Id;
                } else {
                    this.currentQuestionId = this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Id;
                }
                console.log('currentQuestionId', this.currentQuestionId);
            } else {
                this.currentQuestionId = this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Id;
            }
        }
        
        if(this.globalCurrentQuestion >= 86){
            this.toastr.success('Thank you for completing the assessment.', 'ELI');
        }

        if(this.globalCurrentQuestion === 85){
            this.toastr.success('Section 3.  Demographic Questions.', 'ELI');
        }
    

    }

    ngDoCheck() {
        //console.log('ngDoCheck()');
        this.displayDownButtons();
    }

    showNextSection() {
        if (this.currentSectionIndex < (this.sections.length - 1)) {

            this.currentSectionIndex++;
            if (this.sections[this.currentSectionIndex].Questions.length == 0) {
                this.showNextSection();
                return;
            }
            let questionsToAdd = this.questionsToAdd(this.currentSectionIndex);
            this.globalCurrentQuestion = questionsToAdd + 1;

            this.currentQuestionIndex = 0;
            this.currentSectionId = this.sections[this.currentSectionIndex].SectionId;
            this.currentChoiceSetId = this.sections[this.currentSectionIndex].ChoiceSetId;
            console.log('------New section-------');
            this.setSectionProperties();
            //excluiding the multiple choices
            if (this.singleChoice || this.showIcons) {
                this.getChoicesForCurrentSection(this.currentChoiceSetId);
            }
            console.log('currentSectionIndex', this.currentSectionIndex);
            console.log('currentQuestionIndex', this.currentQuestionIndex);
            console.log('currentChoiceSetId', this.currentChoiceSetId);
            console.log('Answer', this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Answer);
            this.currentHeader = this.sections[this.currentSectionIndex].Header;

        } else {
            this.assessmentFinished();
        }
    }

    assessmentFinished() {

        console.log("---Assessment finished!---");
        if (!this.previewMode) {
            $('#showDownButtons').remove();
            this.showDownButtons = false;
            this.processAssessment(this.assignmentId);
            this.showAssessment = false;
            this.loading = true;

            if (this.userType == 3) {
                //this.loadingMessage = 'Generating results.. Please wait.';
                this.loadingMessage = 'Loading.. Please wait.';
                this.hideNavigationBtns = true;
            }
            if (this.userType == 4) {
                this.loadingMessage = 'Please wait.';
                this.hideNavigationBtns = true;
            }

            this.clearAll();
        } else {
            console.log('ASSESSMENT Preview finished');
            this.finish = true;
            this.showAssessment = true;
            this.loading = true;
            this.hideNavigationBtns = true;
            this.setPreviewPageContent(this._Globals.thankyouPageContent, 'thankYouPageContent');
            this.showAssessment = false;

            //this.finishAssessment();
            //this.clearAll();
        }
        setTimeout(() => {
            this.showDownButtons = false;
            $('#showDownButtons').hide();
        }, 100);
    }

    showPrevQuestion() {

        //this.restartCountDown();

        if (this.globalCurrentQuestion <= 1) return;
        //this.globalCurrentQuestion--;

        // if (this.currentQuestionIndex > 0 && (this.displayMode != 2)) {
        //     this.currentQuestionIndex--;
        //     console.log('currentQuestionIndex', this.currentQuestionIndex);
        // } 
        //if {
        this.displayDownButtons();
        this.showPrevSection();
        //}
    }

    showPrevSection() {
        //if (this.currentSectionIndex > 0) {
        //if (this.currentQuestionIndex < (this.sections[this.currentSectionIndex].Questions.length - 1)) { }
        if (!this.singleChoice || this.currentQuestionIndex == 0) {


            this.currentSectionIndex--;
            let currentSectionsingleChoice = this.singleChoice;

            this.currentQuestionIndex = this.sections[this.currentSectionIndex].Questions.length;
            this.currentSectionId = this.sections[this.currentSectionIndex].SectionId;
            this.currentChoiceSetId = this.sections[this.currentSectionIndex].ChoiceSetId;
            console.log('------prev section-------');
            this.setSectionProperties();

            if (currentSectionsingleChoice) {
                //if (this.from == 'rater') {
                //  this.globalCurrentQuestion = 1;
                //} else {
                //excluiding the multiple choices
                if (this.singleChoice || this.showIcons) {
                    this.globalCurrentQuestion--;
                }
                //}
            } else {
                if (this.singleChoice) {
                    this.globalCurrentQuestion = (this.globalCurrentQuestion - 1);
                } else {
                    let questionsToRemove = this.questionsToRemove(this.currentSectionIndex);
                    this.globalCurrentQuestion = (this.globalCurrentQuestion - questionsToRemove);
                }
            }


            //excluiding the multiple choices
            if (this.singleChoice || this.showIcons) {
                this.getChoicesForCurrentSection(this.currentChoiceSetId);
            }
            console.log('currentSectionIndex', this.currentSectionIndex);
            console.log('currentQuestionIndex', this.currentQuestionIndex);
            console.log('currentChoiceSetId', this.currentChoiceSetId);
            this.currentHeader = this.sections[this.currentSectionIndex].Header;
            if (this.displayMode === 1) {
                this.currentQuestionIndex--;
            }
        }
        else {
            this.currentQuestionIndex--;
            this.globalCurrentQuestion--;
        }

        let lastSection = this.sections[this.sections.length - 1].SectionId;
        if (lastSection == this.currentSectionId) {
            //excluiding the multiple choices
            if (!this.singleChoice && !this.showIcons) {
                this.currentQuestionId = this.sections[this.currentSectionIndex].Questions[this.sections[this.sections.length - 1].Questions.length - 1].Id;
            } else {
                this.currentQuestionId = this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Id;
            }
            console.log('currentQuestionId', this.currentQuestionId);
        } else {
            if (this.currentQuestionIndex < this.sections[this.currentSectionIndex].Questions.length) {
                this.currentQuestionId = this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Id;
            }
        }
    }

    displayCommentsSection() {
        $('.commentsSection, .commentsTitle').show();
        $('.questionSection, .questionData').hide();
        this.onCommentsPage = true;
    }

    backFromComments() {
        console.log('backFromComments');
        $('.commentsSection, .commentsTitle').hide();
        $('.questionSection, .questionData').show();
        this.onCommentsPage = false;
    }

    finishAssessmentsWithComments() {

        $('#showDownButtons').css('opacity', 0);
        //$('#showDownButtons').remove();
        console.log('remove btns');

        let data = {
            "gr4": this.assignmentId,
            "wl5": this._Globals.getUserId(),
            "vy8": $('#commentsArea').val()
        };

        this._RatersService.postSaveCommentsData(this._CryptoJs.encrypt(JSON.stringify(data), 'Os6u9y$B&EXH@PcQfTjPtZP4t78!z%7*')).subscribe((data: any) => {
            console.log('postPreventUseDefaultPassword_response', data.result.Result);

            switch (data.result.Result) {
                case 0:
                    this.toastr.error('We are sorry. An unexpected error happened while trying to save the comment', 'ELI');
                    break;

                case 1:
                    this.assessmentFinished();
                    break;
            }
        });
    }


    questionsToAdd(currentSectionIndex: number): number {
        let questionsToAdd = 0;
        for (var i = 0; i < currentSectionIndex; i++) {
            //excluiding the multiple choices
            if (this.sections[i].SingleChoice || this.sections[i].ShowIcons) {
                questionsToAdd += this.sections[i].Questions.length;
            }
        }
        return questionsToAdd;
    }

    questionsToRemove(currentSectionIndex: number): number {
        let questionsToRemove = 0;
        questionsToRemove = this.sections[currentSectionIndex].Questions.length;
        return questionsToRemove;
    }

    finishAssessment() {
        //if (!this.previewMode) {
        //    this.router.navigate(['/app/pending']);
        //}
        //else
        //{
        //    this.router.navigate(['/app/edit_eli', this._Globals.previewAssessmentId]);
        //}

        switch (this.userType) {
            case 1:
                this.router.navigate(['/app/edit_eli', this._Globals.previewAssessmentId]);
                break;
            case 3:
                this.router.navigate(['/app/client_assessments']);
                break;
            case 4:
                this.router.navigate(['/app/rater_assessments']);
                break;
        }

    }

    saveAssessmentAnswer(questionId: number, answerId: number): boolean {
        //console.log(this._ams.sections[this.currentSection].questions[this.currentQuestion]);

        //this.restartCountDown();

        if (this.assignmentId != 0) {
            let sectionId = this.sections[this.currentSectionIndex].SectionId;


            let question = new SaveQuestionDto();
            question.AssignedAssessmentId = this.assignmentId;
            question.SectionId = sectionId;
            question.QuestionId = questionId;
            question.Answer = answerId;

            console.log('current question answer', question);

            /*adding disabled class to the answers, back and next buttons*/
            $(".buttons label, .takingAssessment button").addClass("disabled");
            /*disabling the answers, back and next buttons*/
            $(".takingAssessment input, .takingAssessment button").prop("disabled", true);

            //setTimeout(() => {
            this._ClientsService.postSaveAssessmentAnswer(question).subscribe((data: any) => {
                console.log(data);
                $('.buttons i.fa.fa-spinner.fa-pulse.fa-3x.fa-fw').hide();

                if (data.result.Result > 0) {
                    localStorage.setItem("ELIResponseError", "0");
                    /*enabling all buttons*/
                    $(".buttons label, .takingAssessment button").removeClass("disabled");
                    $(".takingAssessment input, .takingAssessment button").prop("disabled", false);

                    //if (this.singleChoice || this.showIcons) {
                    //    if (this.globalCurrentQuestion == this.questionsTotal && this.showCommentsSection) {
                    //        this.displayCommentsSection();
                    //    } else {
                    //        this.showNextQuestion();
                    //    }
                    //}
                    return true;
                } else {
                    this.toastr.error('We are sorry. An unexpected error happened while trying to register your answer. Please try again. If the problem persists please contact Technical Support.', 'ELI');
                    /*enabling only answers buttons*/
                    $(".buttons label").removeClass("disabled");
                    $(".takingAssessment input").prop("disabled", false);
                    localStorage.setItem("ELIResponseError", "1");

                    /*remove the selected answer*/
                    $(".buttons label").removeClass("active");
                    return false;
                }
            },
                error => {
                    console.error(error);
                    this._Globals._Toastr.error("We are sorry. An error happened while trying to save the answer. If the problem persists please contact iPEC support team.", "ELI");
                    /*enabling only answers buttons*/
                    $(".buttons label").removeClass("disabled");
                    $(".takingAssessment input").prop("disabled", false);
                    /*remove the selected answer*/
                    $(".buttons label").removeClass("active");
                    $('.buttons i.fa.fa-spinner.fa-pulse.fa-3x.fa-fw').hide();
                    localStorage.setItem("ELIResponseError", "1");

                    let data = {
                        'he3': 0,
                        'bo7': error.url,
                        'pm5': "UserId is NaN",
                        'my6': btoa(question + ',' + encodeURIComponent(window.navigator.userAgent))
                    }

                    //this._Globals.clearAllAndRediretToLogin();

                    this._Globals.postSaveAtLog(this._Globals._CryptoJs.encrypt(JSON.stringify(data), '7s6v9y$B&E)M@MxQfTjWnZq4t7x@z%C*')).subscribe((_data: any) => {
                        console.log('response_postSaveAtLog', _data);
                        this._Globals.validationToken(_data.result.Result);
                    });
                });
            //}, 10000);

        } else {
            console.log('preview mode');
            return false;
        }
    }

    //-----------------------------------------
    //-----validations-------------------------
    //-----------------------------------------


    setOneActive(event: any) {
        console.log('setOneActive', event);
        //if ($(".buttons input").hasClass("disabled")) return;

/*        $(event.currentTarget.childNodes[3]).css('display', 'inline-block');*/

        //if (event.currentTarget.nodeName == "LABEL") { }
        /*let answerId = parseInt(event.target.id);*/
        let answerId = event.target.id.match(/\d/g);
        answerId = parseInt(answerId.join(""));

/*        let children = event.target.parentNode.parentNode.children.length;*/
/*        for (let i = 0; i < children; i++) {*/
            //let lastClass = event.target.parentNode.parentNode.children[i].children["0"].classList.length
/*            event.target.parentNode.parentNode.children[i].children["0"].classList.remove('active');*/
/*        }*/
/*        event.target.classList.add('active');*/
        //.target.parentNode.parentNode.children[3].children["0"].classList

        let questionId = this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Id;
        this.saveAssessmentAnswer(questionId, answerId);
        //setting the current selected answer
        this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Answer = answerId;
    }

    validateSingleQuestions(): boolean {
        if (this.displayMode == 1 && this.singleChoice) {
            let answer = $('input[name=answers]:checked').val();
            console.log(answer);
            if (answer == undefined) {
                //alert('Please select one answer');
                this.toastr.warning('Please select one answer.', 'ELI');
                return false;
            }
            else {
                $('input[name=answers]').prop('checked', false);
                $('.btn-group label').removeClass('active');
                return true;
            }
        }
        else {
            return true;
        }
    }

    selectFace(event: any, questionIndex: string) {
        //console.log(this._ams.sections[this.currentSection].questions[this.currentQuestion]);
        let answerId = parseInt(event.target.dataset.choiceId);
        let questionId = parseInt(event.target.dataset.questionId);

        console.log('choiceId', questionId);
        console.log('answerId', answerId);

        let children = event.target.parentNode.parentNode.children.length;
        //for (let i = 0; i < children; i++) {
        //    event.target.parentNode.parentNode.children[i].children["0"].classList.remove('active');
        //}
        //event.target.classList.add('active');
        //console.log(event);
        this.setSelectedFaceValue(questionIndex, event.target.classList["0"], answerId);

        this.saveAssessmentAnswer(questionId, answerId);
        //.target.parentNode.parentNode.children[3].children["0"].classList
        //setting the current selected answer
        this.setSelectedQuestionAnswer(questionId, answerId);
    }

    setSelectedQuestionAnswer(questionId: number, answerId: number) {
        for (let i = 0; i < this.sections[this.currentSectionIndex].Questions.length; i++) {
            if (this.sections[this.currentSectionIndex].Questions[i].Id == questionId) {
                this.sections[this.currentSectionIndex].Questions[i].Answer = answerId;
                return;
            }
        }
    }

    setSelectedFaceValue(questionIndex: string, classValue: string, answerId: number) {
        $("input[name='face" + questionIndex + "']").val(classValue);
        $("input[name='face" + questionIndex + "']").prop('checked', true);
        console.log(classValue);
    }

    validateFacesQuestions(): boolean {
        if (this.displayMode == 2 && this.singleChoice) {
            let allCompleted = true;
            let sectionQuestions = this.sections[this.currentSectionIndex].Questions.length;
            for (var i = this.globalCurrentQuestion; i < this.globalCurrentQuestion + sectionQuestions; i++) {
                let answer = $("input[name='face" + i + "']").val();
                if (answer == '') {
                    //alert('Please complete all questions');
                    this.toastr.warning('Please complete all questions.', 'ELI');
                    allCompleted = false;
                    return allCompleted;
                }
            }
            return allCompleted;
        }
        else {
            return true;
        }
    }

    selectSurvey(selected: any, event: any) {
        //console.log(event);
        //console.log(this._ams.sections[this.currentSection].questions);

        //getting the question id
        let questionId = event.target.id;
        let numRegex = /\d/g; // Change this line
        let result = questionId.match(numRegex);
        console.log(result);
        let id = parseInt(result.join(""));
        console.log('questionId', id);

        //getting the position on the array
        let index = this.sections[this.currentSectionIndex].Questions.findIndex(x => x.Id === id);

        //getting the entire object for the current question
        let currentQuestion = this.sections[this.currentSectionIndex].Questions[index];
        console.log('current question', currentQuestion);

        currentQuestion.RelateQuestionRules.forEach((item) => {
            this.executeRelatedRules(item.RelatedQuestion);
        });

        let selectedValue = selected;
        console.log('survey selected', selectedValue);

        //validation for index 0 of the options
        if (selectedValue != '') {
            this.saveAssessmentAnswer(id, parseInt(selectedValue));
        }

        //setting the current selected answer
        this.setSelectedQuestionAnswer(id, selected);

        // if allow free entry
        const choice = currentQuestion.Choices.find((c: any) => Number(c.Id) === Number(selected));
        if (choice && choice.AllowFreeEntry) {
            $('#input' + currentQuestion.Id).val('');
            $('#input' + currentQuestion.Id).show();
        } else {
            $('#input' + currentQuestion.Id).hide();

            this._ClientsService.postRemoveFreeEntryAnswer(currentQuestion.Id, this.assignmentId)
                .subscribe((response: any) => {
                    console.log('response_postRemoveFreeEntryAnswer', response);
                    if (this._Globals.validationToken(response.result.Result)) {
                        return;
                    }

                    this.toastr.error('We are sorry.  An error happened while change answer.  Please contact customer support.', 'ELI');
                },
                    (err) => {
                        this.toastr.error('We are sorry.  An error happened while change answer.  Please contact customer support.', 'ELI');
                    });
        }
    }

    validateSurveyQuestions(): boolean {
        if (!this.showIcons && !this.singleChoice) {
            let selects = this.selectsElement.nativeElement.getElementsByTagName('select');

            let allSelected = true;
            for (var i = 0; i < selects.length; i++) {
                let questionId = selects[i].id;
                let numRegex = /\d/g; // Change this line
                let result = questionId.match(numRegex);
                console.log(result);
                let id = parseInt(result.join(""));
                console.log('questionId', id);

                this.executeRelatedRules(id);

                if (selects[i].className == "isMandatory" && selects[i].parentNode.parentNode.style.display != "none") {
                    const input: any = document.getElementById('input' + id);

                    if (input.style.display != "none" && input.value === '') {
                        this.toastr.warning('Please complete all of the mandatory questions.', 'ELI');
                        setTimeout(() => {
                            input.focus();
                            input.style.setProperty('box-shadow', '0px 0px 15px 3px #4d9fd5');
                            input.style.setProperty('-webkit-box-shadow', '0px 0px 15px 3px #4d9fd5');
                        }, 5);

                        setTimeout(() => {
                            input.style.setProperty('box-shadow', 'none');
                            input.style.setProperty('-webkit-box-shadow', 'none');
                        }, 2505);

                        return false;
                    }

                    if (selects[i].selectedIndex == 0) {
                        this.toastr.warning('Please complete all of the mandatory questions.', 'ELI');
                        allSelected = false;
                    }
                }
            }
            return allSelected;
        }
        else {
            return true;
        }
    }

    executeRelatedRules(relatedQuestionId: number) {

        //getting the position on the array
        let index = this.sections[this.currentSectionIndex].Questions.findIndex(x => x.Id === relatedQuestionId);

        if (index === -1) {
            return;
        }

        //let currentIndex = parseInt(selects[i].dataset.index);
        let currentQuestion = this.sections[this.currentSectionIndex].Questions[index];
        if (currentQuestion.Rules.length > 0) {
            console.log(`relatedQuestionId ${relatedQuestionId} Have Rules`, currentQuestion);

            let conditionsCounter = 0;
            let conditions = currentQuestion.Rules[0].Conditions;
            let meetsCondition = false;
            while (conditionsCounter < conditions.length) {
                var e = document.getElementById('select' + conditions[conditionsCounter].RelatedQuestion);
                let condition1 = $(`#select${conditions[conditionsCounter].RelatedQuestion}`).val();
                let condition2 = conditions[conditionsCounter].ChoiceId;
                if (condition1 == condition2) {
                    meetsCondition = true;
                }
                conditionsCounter++;
            }

            if (meetsCondition) {
                if (currentQuestion.Rules[0].RuleType == 1) { //visibility
                    $('#label' + relatedQuestionId).parent().parent().hide();
                } else if (currentQuestion.Rules[0].RuleType == 2) { //mandatory
                    this.sections[this.currentSectionIndex].Questions[index].IsMandatory = true;
                    //selects[i].classList.add("isMandatory");
                }
            } else {
                if (currentQuestion.Rules[0].RuleType == 1) { //visibility
                    $('#label' + relatedQuestionId).parent().parent().show();
                } else if (currentQuestion.Rules[0].RuleType == 2) { //mandatory
                    this.sections[this.currentSectionIndex].Questions[index].IsMandatory = false;
                    //selects[i].classList.remove("isMandatory");
                }
            }

        }
    }

    clearAll() {
        this.currentSectionIndex = 0;
        this.currentQuestionIndex = 0;
        this.showNextIcon = false;
        this.sections = [];
        this.currentSectionChoices = [];
        this.multipleQuestions = [];
        this.questionChoices = [];
        this.questionsContent = false;

        console.log('All clear!!');
    }


    /*FINISH*/
    processAssessment(assignmentId: number) {
        let processAssessmentDto = new ProcessAssessmentDto();
        processAssessmentDto.assignmentId = assignmentId;
        processAssessmentDto.userType = this.userType;

        this.finish = true;
        this.loading = false;
        this.showAssessment = true;


        //call the service for thank you page
        console.log('ASSESSMENT finished successfully');
        this.getPageContentByUserType(this.assessmentId, 2, this.language, this.userType, 'thankYouPageContent');
            
    }

    downloadAssessment() {
        console.log('download_assessment');

        window.location.href = 'https://eli-services.softcial.net/AdminService.svc/GetAssessmentReport?clientId=3&assignmentId=' + this.assignmentId;
    }



    //---------------------------------------------------
    //-------------------instructions--------------------
    //---------------------------------------------------

    userReady() {
        this.ready = true;

        //this.countDown();

        //get window width
        var w = window.innerWidth;
        if (w < 992) {
            this.showDownButtons = true;
            this.responsiveButtons = true;
        } else {
            this.showDownButtons = false;
            this.responsiveButtons = false;
        }
        //console.log("W", w);
        //console.log('responsive Buttons', this.responsiveButtons);

        //getting the select combo
        //this.selectModeClone = $('.selectMode select').hide();
        //setting the new headder
        //let newContent = "<div class='selectTitle'><h4>Energy Leadership Index</h4></div>";
        //$('.selectMode').prepend(newContent);

        if (this.assignmentId != 0) {
            //this._ClientsService.getAssignedAssessment(this.assignmentId, this.userType).subscribe((_data: any) => {

            //console.log('response_GetAssignedAssessment', this.data);
            //if (this._Globals.validationToken(_data.result.Result)) {
            //let data = JSON.parse(_data.result.Data);
            console.log('_data', this.data);

            this.sections = this.data.Sections;
            this.showCommentsSection = this.data.ShowCommentsSection;
            console.log('sections', this.sections);

            if (this.sections[0].Questions.length == 0) {
                this.finish = true;
                this.toastr.warning("This assessment does't have sections to show.", "ELI");
                return;
            }

            if (this.data.Progress == null) {
                this.currentSectionId = 0;
                this.currentQuestionId = 0;
            } else {
                this.currentSectionId = this.data.Progress.CurrentSection;
                this.currentQuestionId = this.data.Progress.CurrentQuestion;
            }

            //for new assessment
            //this.currentSectionId = 0;
            //this.currentQuestionId = 0;

            if (this.currentSectionId != 0) {
                //take edited assessment
                this.currentSectionIndex = this.getSectionIdPositionIndex(this.currentSectionId, this.data.Sections);
                //if (this.currentSectionIndex === 0) {
                //    if (this.from === "rater") {
                //        this.currentQuestionIndex = 0;
                //    } else {
                //        this.currentQuestionIndex = this.getQuestionIdPositionIndex(this.currentQuestionId, data.Sections[this.currentSectionIndex].Questions);
                //    }
                //} else {
                this.currentQuestionIndex = this.getQuestionIdPositionIndex(this.currentQuestionId, this.data.Sections[this.currentSectionIndex].Questions);
                //}
                let questionsToAdd = this.questionsToAdd(this.currentSectionIndex);

                if (this.currentSectionIndex == 0) {
                    if (this.from == 'rater') {
                        this.globalCurrentQuestion = 1;
                    } else {
                        this.globalCurrentQuestion = this.currentQuestionIndex + 1;
                    }
                } else {
                    this.globalCurrentQuestion = questionsToAdd + this.currentQuestionIndex + 1;
                }
            } else {
                //for new assessment
                this.currentSectionIndex = 0;
                this.currentQuestionIndex = 0;
                this.currentSectionId = this.sections[0].SectionId;
            }

            this.currentChoiceSetId = this.data.Sections[this.currentSectionIndex].ChoiceSetId;
            this.currentHeader = this.data.Sections[this.currentSectionIndex].Header;
            this.setSectionProperties();

            this.questionsTotal = this.getTotalQuestions(this.data.Sections);

            console.log('currentChoiceSetId', this.currentChoiceSetId);
            console.log('currentSectionId', this.currentSectionId);
            console.log('currentQuestionId', this.currentQuestionId);
            console.log('currentSectionIndex', this.currentSectionIndex);
            console.log('currentQuestionIndex', this.currentQuestionIndex);
            console.log('total questions', this.questionsTotal);

            this.getChoicesForCurrentSection(this.currentChoiceSetId);

            let lastSection = this.sections[this.sections.length - 1].SectionId;
            if (lastSection == this.currentSectionId) {
                //excluiding the multiple choices
                if (!this.singleChoice && !this.showIcons) {
                    this.currentQuestionId = this.sections[this.currentSectionIndex].Questions[this.sections[this.sections.length - 1].Questions.length - 1].Id;
                } else {
                    this.currentQuestionId = this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Id;
                }
                console.log('currentQuestionId', this.currentQuestionId);
            } else {
                this.currentQuestionId = this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Id;
            }

            this.showAssessment = true;
            this.loading = false;

            setTimeout(() => {
                if (!this.singleChoice && !this.showIcons) {
                    this.sections[this.currentSectionIndex].Questions.forEach((item) => {
                        this.executeRelatedRules(item.Id);
                    });
                }
            }, 1000);

            // }

            //});
        }
        else {
            console.log('preview JSON', this._Globals.previewModeJSON);
            if (this._Globals.previewModeJSON == undefined) {
                this.toastr.warning('No assigned Assessment loaded', 'ELI');
                return;
            } else {
                this.sections = this._Globals.previewModeJSON.result.Sections;

                this.currentSectionIndex = 0;
                this.currentQuestionIndex = 0;
                this.currentSectionId = this.sections[0].SectionId;
                this.currentChoiceSetId = this.sections[0].ChoiceSetId;

                this.setSectionProperties();

                this.questionsTotal = this.getTotalQuestions(this._Globals.previewModeJSON.result.Sections);

                if (this.questionsTotal == 0) {
                    this.showAssessment = true;
                    this.loading = false;
                    this.finish = true;
                    console.log("assessment doesn't have questions");
                    return;
                }

                console.log('currentChoiceSetId', this.currentChoiceSetId);
                console.log('currentSectionId', this.currentSectionId);
                console.log('currentQuestionId', this.currentQuestionId);
                console.log('currentSectionIndex', this.currentSectionIndex);
                console.log('currentQuestionIndex', this.currentQuestionIndex);
                console.log('total questions', this.questionsTotal);

                if (this.sections[this.currentSectionIndex].Questions.length == 0) {
                    this.showNextSection();
                    this.showAssessment = true;
                    this.loading = false;
                    return;
                } else {
                    this.getChoicesForCurrentSection(this.currentChoiceSetId);
                    this.showAssessment = true;
                    this.loading = false;
                }
            }
        }
    }

    getIndexForCurrentQuestion(): number {
        return this.sections[this.currentSectionIndex].Questions.findIndex(x => x.Id === this.currentQuestionId);
    }

    //getPageContent(assessmentId: number, language: string) {
    //    this._AssessmentsService.getPageContent(assessmentId, 1, language).subscribe((data: any) => {
    //        console.log("response_getPageContent", data);

    //        this.loading = false;

    //        if (this._Globals.validationToken(data.result.Result)) {
    //            let _data = JSON.parse(data.result.Data);
    //            console.log('getPageContent', _data);
    //            this.pageContent = _data.Content;
    //            if (this.pageContent == "") {
    //                this.pageContent = '<div style="text-align:center;margin-top:20px;"><i class="fas fa-exclamation-triangle"></i> No content.</div>';
    //            }

    //            $('#pageContent').html(this.pageContent);
    //            $('.ql-align-justify img').css('width', '100%');
    //            $('p img').css('margin', '3px 0');
    //            $('p').css('margin', '0px');

    //            let w = $(window).width();
    //            console.log(w);
    //            if (w < 1260) {
    //                $('p img').css('display', 'list-item');
    //            }

    //        }
    //    });
    //}

    getPageContentByUserType(assessmentId: number, pageType: number, language: string, userType, divId: string) {
        this.gettingData.push('getPageContentByUserType');
        this._AssessmentsService.getPageContentByUserType(assessmentId, pageType, language, userType, this.assignmentId).subscribe((data: any) => {
            console.log("response_getPageContent", data);

            this.loading = false;

            if (this.finish || this.assessment360Finished) {
                this.showDownButtons = false;
                $('#showDownButtons').remove();
            }

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('getPageContent', _data);
                this.pageContent = _data.Content;
                if (this.pageContent == "") {
                    this.pageContent = '<div style="text-align:center;margin-top:20px;"><i class="fas fa-exclamation-triangle"></i> No content.</div>';
                }

                $('#' + divId).html(this.pageContent);
                $('.ql-align-justify img').css('width', '100%');
                $('p img').css('margin', '3px 0');
                $('p').css('margin', '0px');

                let w = $(window).width();
                console.log(w);
                if (w < 1260) {
                    $('p img').css('display', 'list-item');
                }

            }
            this.gettingData.splice(this.gettingData.indexOf('getPageContentByUserType'), 1);
        },
            (err) => {
                this.gettingData.splice(this.gettingData.indexOf('getPageContentByUserType'), 1);
            });
    }

    saveFreeEntryAnswer(questionChoiceId: number, event: any): void {
        if (!questionChoiceId) {
            return;
        }
        const answer = String(event.target.value).trim();

        if (!answer || answer.trim().length === 0) {
            if (this.questionChoices.find(q => q.Id === questionChoiceId).IsMandatory) {
                $('#input' + questionChoiceId).val('');
            }
        }

        this._ClientsService.postSaveFreeEntryAnswer(questionChoiceId, this.assignmentId, answer)
            .subscribe((response: any) => {
                console.log('response_postSaveFreeEntryAnswer', response);
                if (this._Globals.validationToken(response.result.Result)) {
                    return;
                }

                this.toastr.error("We are sorry.  An error happened while processing your answer.  Please contact customer support.", "ELI");
            },
                (error) => {
                    this.toastr.error("We are sorry.  An error happened while processing your answer.  Please contact customer support.", "ELI");
                });
    }

    authenticateUser() {
        $('body').css('cursor', 'wait');
        $(".btn").prop("disabled", true);


/*        this._AdminService.postAuthenticateUser(email, this._CryptoJs.encrypt(pass, '3s6v9y$B&E)H@McQfTjWnZq4t7w!z%C*'))*/
        this._AdminService.getAccessibleAssessmentData(this.guidId)
            .subscribe(
                data => {
                    console.log('data', data.result);

                    switch (data.result.Result)
                    {
                        //case -20:
                        //    this.toastr.error('Invalid login credentials. If you are a Hub user please use your Hub credentials to log in', 'ELI');
                        //    $('body').css('cursor', 'default');
                        //    $(".btn").prop("disabled", false);
                        //    break;

                        case 1:
                            let accessibleAssessmentData = JSON.parse(data.result.Data);
                            console.log('data', accessibleAssessmentData);

                            this.assessmentId = parseInt(accessibleAssessmentData.AssessmentId);
                            this.language = accessibleAssessmentData.Language;
                            this.translate.use(this.language);
                            this.from = 'pending';
                            this.currentAssessmentName = accessibleAssessmentData.AssessmentName;
                            this.assignmentId = parseInt(accessibleAssessmentData.AssignmentId);
                            this.fullName = accessibleAssessmentData.AuthenticateUser.FirstName + " " + accessibleAssessmentData.AuthenticateUser.LastName;

                            //if (this.assessmentId != -1) {
                            //    this.hasId = true;
                            //}


                            this.setAllBooleans(false);
                            switch (this.from) {
                                case "eli_assessments":
                                    //this.from_admin = true;
                                    this.previewMode = true;
                                    this.userType = 1;
                                    break;
                                case "pending":
                                    //this.from_client = true;
                                    this.previewMode = false;
                                    this.userType = 3;
                                    break;
                                case "rater":
                                    this.userType = 4;
                            }

                            this._UserLoggedInService.setUserLoggedIn(true);
                            this.idle.watch();
                            this._Globals.setAnnouncementsStatus(true);

                            this._Globals.setToken(accessibleAssessmentData.AuthenticateUser.AccessToken);
                            this._Globals.setFullName(accessibleAssessmentData.AuthenticateUser.DskjoXCn0f, accessibleAssessmentData.AuthenticateUser.QyKZJFsEvu);
                            this._Globals.setUserId(accessibleAssessmentData.AuthenticateUser.OepbCPnScZ);
                            let mode;
                            if (this._CryptoJs.decrypt(accessibleAssessmentData.AuthenticateUser.Mode, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*') == 'Manager') {
                                mode = this._CryptoJs.encrypt('Administrator', '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*');
                                this._Globals.setUserType("manager");
                            } else {
                                mode = accessibleAssessmentData.AuthenticateUser.Mode;
                                this._Globals.setUserType("Administrator");
                            }
                            this._Globals.setMode(mode);
                            this._Globals.setAvailableModes(accessibleAssessmentData.AuthenticateUser.Modes);

                            this._Globals.setUserEmail(this._CryptoJs.encrypt(this.user.email, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                            this._Globals.setCanUserEditEmail(accessibleAssessmentData.AuthenticateUser.YE3 == 1 ? true : false);
                            this._Globals.setIsUserStudent(accessibleAssessmentData.AuthenticateUser.NR9);

                            this.authenticateUserData = data.result;
                            
                            this.getAssignedAssessment();

                            break;

                        default:
                            //-1 invalid user
                            //0 invalid password
                            this.assessmentValid = false;
                            this.toastr.error('We are sorry. The url seems not be a valid assessment', 'ELI');
                            this.ngProgressRef.complete();
                            this.loading = false;
                            break;
                    }
                    $('body').css('cursor', 'default');
                    $(".btn").prop("disabled", false);
                },
                error => {
                    console.error(error);
                    this.toastr.error('An error happen please try again.', 'ELI');
                    $('body').css('cursor', 'default');
                    $(".btn").prop("disabled", false);
                },
                () => {
                    //console.log("No errors");
                    // No errors, route to new page
                }
            );
    }
}
